/**
 * Estado del configurador BUBBLE que no depende de React: semillas, historial
 * de distribuciones y qué campos del schema se ven según lo elegido.
 *
 * Todo vive en `form2d_data.bubble`, así que guardar el diseño guarda también
 * su historial y la semilla con la que se reproduce.
 */
import { patchPath, readPath } from '../../products/registry.js';

export const SEED_HISTORY_LIMIT = 10;
const MAX_SEED = 2147483647;

export const currentSeed = (values) => Number(readPath(values, 'bubble.seed') ?? 1);

export const seedHistory = (values) => {
    const history = readPath(values, 'bubble.seedHistory');
    return Array.isArray(history) ? history : [];
};

/** Semilla nueva, distinta de la actual. `random` se inyecta para poder testear. */
export const randomSeed = (current, random = Math.random) => {
    let seed = current;
    while (seed === current) seed = 1 + Math.floor(random() * (MAX_SEED - 1));
    return seed;
};

/** «Generar nuevas pompas»: misma configuración, otra semilla; la actual pasa al historial. */
export const withNewSeed = (values, random = Math.random) => {
    const seed = currentSeed(values);
    const history = [seed, ...seedHistory(values)].slice(0, SEED_HISTORY_LIMIT);
    return patchPath(patchPath(values, 'bubble.seedHistory', history), 'bubble.seed', randomSeed(seed, random));
};

/** «Distribución anterior»: recupera la última semilla del historial, si la hay. */
export const withPreviousSeed = (values) => {
    const [previous, ...rest] = seedHistory(values);
    if (previous === undefined) return values;
    return patchPath(patchPath(values, 'bubble.seedHistory', rest), 'bubble.seed', previous);
};

/** Campos que no aplican a lo elegido: las medidas a mano sin «Personalizada», la inclinación sin «Inclinada». */
export const hiddenFieldsFor = (values, alwaysHidden = []) => {
    const hidden = [...alwaysHidden];
    if (readPath(values, 'bubble.napkinPreset') !== 'custom') {
        hidden.push('napkin_width_mm', 'napkin_height_mm');
    }
    if (readPath(values, 'bubble.orientation') !== 'tilted') hidden.push('tilt_deg');
    return hidden;
};

/** Lo que cambia la geometría: todo `bubble` salvo el color y el historial. */
export const geometryKey = (values) => {
    const geometry = { ...(readPath(values, 'bubble') || {}) };
    delete geometry.bodyColor;
    delete geometry.seedHistory;
    return JSON.stringify(geometry);
};
